export const structuralCategoryKeys = {
  all: ["structuralCategory"] as const,
  project: (projectId: string | null) => [...structuralCategoryKeys.all, projectId] as const,
};
